import { createContext, ReactNode, useContext } from "react";
import { Props } from "../shared/types/Props";
import { ContextType, DataProvider } from "./DataProvider";

const PropsDataContext = createContext<ContextType<Props> | null>(null);

export const PropsDataProvider = ({ children }: { children: ReactNode }) => (
  <DataProvider context={PropsDataContext} collection="props">
    {children}
  </DataProvider>
);

export const usePropsData = () => {
  const context = useContext(PropsDataContext);
  if (!context) {
    throw new Error("usePropsData must be used within a PropsDataProvider");
  }
  return context;
};
